// src/api/myaccount/authApi.js
import axios from "axios";
import { LOGINOTPGENERATEURL } from "../index";
import authHeader from "../../api/HeaderPayload";
export const getauthApi = (postData) => {
  return axios.post(LOGINOTPGENERATEURL, postData,{header:authHeader()});
};
